<div class="modal-header align-items-center">
  <h4 class="modal-title">{{ content.title }}</h4>

  <button type="button" class="btn btn-xs btn-icon btn-transparent" (click)="close(false)">
    <i class="material-icons mi-18">close</i>
  </button>
</div>

<div class="modal-body">
  <p>{{ content.body }}</p>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="close(false)">
    {{ content.abort }}
  </button>
  <button type="button" class="btn btn-danger" (click)="close(true)">
    {{ content.confirm }}
  </button>
</div>
